import Header from "../../components/shared/Header";
import "../../styles/shared/Plans.scss";
import HeroImage from "../../images/business.png";
import SolutionImage1 from "../../images/c-emission-report.png";
import SolutionImage2 from "../../images/cc-monitoring-certificate.png";
import SolutionImage3 from "../../images/verification.png";
import SolutionImage4 from "../../images/SolutionImage3.png";
import efficiency  from "../../images/efficiency.png";

import Focus from "../../images/potentialBussiness.png";
import { useEffect, useState } from "react";
import GreenLogo from "../../images/Group 32.png";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/shared/Footer";
import Collaborators from "../../components/shared/Collaborators";
import BusinessFaq from "../../components/NewLandingPage/BusinessFaq";

export default function Business() {
  const navigate = useNavigate();
  const [type, setType] = useState("tracking");
  const [planVideo, setplanVideo] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const nextBtn = document.querySelector(".feedback__inner__group__svg-group__next");
    const prevBtn = document.querySelector(".feedback__inner__group__svg-group__prev");
    const slider = document.querySelector(".feedback__inner__cards");
    const card = document.querySelector(".feedback__inner__cards__card");
    let itemDimensions = card.getBoundingClientRect();
    let amountToSlide = (itemDimensions.width + 24) * 3;

    nextBtn.addEventListener("click", () => {
      slider.scrollLeft += amountToSlide;
      console.log(
        'nextBtn', nextBtn,
        'prevBtn', prevBtn,
        'slider', slider,
        'card', card,
        'itemDimensions', itemDimensions,
        'amountToSlide', amountToSlide
      );
    });

    prevBtn.addEventListener("click", () => {
      slider.scrollLeft -= amountToSlide;
    });

  }, [])

  return (
    <div className="plans">
      <Header />
      <div className="hero">
        <div className="hero__inner">
          <div className="hero__inner__title">
            CloseCarbon <span>Business</span>
          </div>
          <div className="hero__inner__subtitle">
Carbon Reporting. Certification. Incentives. Energy Efficiency.          </div>
          <div className="hero__inner__price">
            Starting at ₦15,995 <span>Monthly</span>
          </div>
          <div className="hero__inner__button-group">
            <button onClick={() => navigate('/template/business')}>Choose plan</button>
            <button
             onClick={() => {
              window.open("https://youtu.be/On9PHYLfZOk?si=Wtdk1jT5j71VwzFl", "_blank", "noopener,noreferrer");
            }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.155 13.7501C3.96313 13.7497 3.77466 13.6994 3.60812 13.6041C3.23312 13.3916 3 12.9791 3 12.5313V3.46881C3 3.01974 3.23312 2.60849 3.60812 2.39599C3.77863 2.298 3.97232 2.24761 4.16896 2.25009C4.36559 2.25256 4.55796 2.30781 4.72594 2.41006L12.4712 7.04631C12.6327 7.14752 12.7657 7.28807 12.858 7.45479C12.9502 7.6215 12.9986 7.8089 12.9986 7.99943C12.9986 8.18996 12.9502 8.37736 12.858 8.54408C12.7657 8.71079 12.6327 8.85134 12.4712 8.95256L4.72469 13.5901C4.55278 13.694 4.35588 13.7493 4.155 13.7501Z"
                  fill="#0FA958"
                />
              </svg>
              Watch now
            </button>
          </div>

          <img loading='lazy' className="hero__inner__img" src={HeroImage} alt="" />
        </div>
      </div>
      <div className="solution">
        <div className="solution__title">
            The <span>solution</span> you need for the sustainability journey <br></br> you want
        </div>
        <div className="solution__subtitle">
         Designed for organizations seeking structured carbon monitoring, verified reporting, and energy performance optimization.
        </div>
        <div className="solution__grid">
          <div className="solution__grid__nav">
            <div
              className={
                type === "tracking"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("tracking")}
            >
              <div className="solution__grid__nav__item__title">Downloadable Carbon emission report</div>
              {type === "tracking" && (
                <div className="solution__grid__nav__item__subtitle">
Generate comprehensive, downloadable carbon emissions reports. Maintain transparency, track performance over time, and support compliance with sustainability and corporate reporting goals.                 </div>
              )}
            </div>
            <div
              className={
                type === "credit"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("credit")}
            >
              <div className="solution__grid__nav__item__title">
              Carbon monitoring certificate
              </div>
              {type === "credit" && (
                <div className="solution__grid__nav__item__subtitle">
Receive an official Carbon Monitoring Certificate recognizing your commitment to structured emissions tracking and performance improvement.                </div>
              )}
            </div>
            <div
              className={
                type === "verification"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("verification")}
            >
              <div className="solution__grid__nav__item__title">
                Verification
              </div>
              {type === "verification" && (
                <div className="solution__grid__nav__item__subtitle">
Your emissions data is independently reviewed by certified verifiers to ensure accuracy, reliability, and compliance with recognized carbon methodologies and standards.                 </div>
              )}
            </div>
           <div
              className={
                type === "efficiency"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("efficiency")}
            >
              <div className="solution__grid__nav__item__title">
              Energy Efficiency
              </div>
              {type === "efficiency" && (
                <div className="solution__grid__nav__item__subtitle">It provides real-time energy monitoring, identifies high-consumption areas, and suggest smart efficiency actions to help facilities make smarter energy decisions.                </div>
              )}
            </div>
            <div
              className={
                type === "insights"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("insights")}
            >
              <div className="solution__grid__nav__item__title">
           Carbon Incentive (CCRTs)
              </div>
              {type === "insights" && (
                <div className="solution__grid__nav__item__subtitle">
Earn CloseCarbon credits for verified emissions reductions and measurable energy efficiency improvements. </div>              )}
            </div>
          </div>
          {type === "tracking" && (
            <img loading='lazy' src={SolutionImage1} className="solution__grid__img" />
          )}
          {type === "credit" && (
            <img loading='lazy'  src={SolutionImage2} className="solution__grid__img" />
          )}
          {type === "verification" && (
            <img src={SolutionImage3} className="solution__grid__img" />
          )}
          {type === "efficiency" && (
            <img loading='lazy' src={efficiency} className="solution__grid__img"  />
          )}
           {type === "insights" && (
            <img loading='lazy' src={SolutionImage4} className="solution__grid__img" />
          )}
        </div>
      </div>
      <div className="feedback">
        <div className="feedback__inner">
          <div className="feedback__inner__group">
            <div className="feedback__inner__group__title">
              Feedback from our customers
            </div>
            <div className="feedback__inner__group__subtitle">
              We’re trusted by several organizations
            </div>
            <div className="feedback__inner__group__svg-group">
              <div className="feedback__inner__group__svg-group__prev">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM17 7L1 7V9L17 9V7Z" />
                </svg>
              </div>

              <div className="feedback__inner__group__svg-group__next">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM0 9H16V7H0L0 9Z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="feedback__inner__cards">
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
This plan was the best fit for our organization. It connected us with a verifier and ensured our reports were valid and credible. It’s a full package for companies aiming for verified sustainability progress.                         </div>
              <div className="feedback__inner__cards__card__subtitle">
         Temi Balogun
              </div>
              <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
We needed a plan that supports both emission tracking and proper documentation. The Business Plan gave us that and more. It streamlined our compliance and saved us valuable time.
               </div>
              <div className="feedback__inner__cards__card__subtitle">
             Nathan Moreau
              </div>
              <div></div>

            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
The Business Plan helped us automate our reporting and get our carbon monitoring certificate with ease. Having a sub-verifier assigned gave us confidence in the process. It’s ideal for facilities that want structured support.
                </div>
              <div className="feedback__inner__cards__card__subtitle">
              Elena Strauss
              </div>
              <div></div>
            </div>
            {/* <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              CloseCarbon's governance plan made it incredibly easy for me to track my carbon emissions. I'm impressed with the simplicity and effectiveness of the tools provided.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              I've been using CloseCarbon's governance plan for a month now, and I'm already seeing positive changes in my carbon footprint. The real-time tracking feature is especially helpful in keeping me accountable.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              This governance plan makes me feel more empowered to make sustainable choices in my daily life. The user-friendly interface have been instrumental in guiding me towards a greener lifestyle.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div> */}
            
          </div>
        </div>
      </div>

      <div className="unlock">
        <div className="unlock__card1">
          <div className="unlock__card1__title">
          Unlock the potential of <span className="text-[#0D924F]"> CloseCarbon Business plan</span>
          </div>
          <div className="unlock__card1__subtitle">
Organizations may engage Regional Oversight and Non-Accredited Endorsing Bodies (SUB-CCVs) to review and approve emissions data. This provides an additional layer of transparency and regional alignment          </div>
          <img loading='lazy' className="unlock__card1__img" src={Focus} alt="" />
        </div>
        <div className="unlock__card2">
          <div className="unlock__card2__flex">
            <img loading='lazy' src={GreenLogo} />
            <div>
              <div className="text-[20px]">Business</div>
              <div>Certification & Report  </div>
            </div>
               <div className="text-[#0D924F] text-6xl font-bold ml-60">₦15,995
            <div className="text-end text-gray-500 mt-2">Monthly</div>

               </div>
          </div>
          <div className="unlock__card2__divider"></div>
          <div className="unlock__card2__price">
           

          </div>

          <div className="unlock__card2__more-info">
            <div className="unlock__card2__more-info__title">How it works:</div>
            <div className="unlock__card2__more-info__flex">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M17.329 19.4985C17.329 17.9661 16.7203 16.4965 15.6367 15.413C14.5532 14.3294 13.0836 13.7207 11.5512 13.7207C10.0189 13.7207 8.54925 14.3294 7.46571 15.413C6.38217 16.4965 5.77344 17.9661 5.77344 19.4985" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.5564 13.7222C13.5508 13.7222 15.1675 12.1055 15.1675 10.1111C15.1675 8.11675 13.5508 6.5 11.5564 6.5C9.56206 6.5 7.94531 8.11675 7.94531 10.1111C7.94531 12.1055 9.56206 13.7222 11.5564 13.7222Z" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.2139 18.7781C20.2139 16.3442 18.7694 14.0836 17.325 13.0003C17.7998 12.6441 18.1795 12.1763 18.4304 11.6384C18.6813 11.1005 18.7958 10.509 18.7637 9.91627C18.7315 9.32357 18.5538 8.74792 18.2462 8.24028C17.9386 7.73264 17.5105 7.30866 17 7.00586" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


              <div>
              Choose a trusted local verifying body to review your emissions data.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
       <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M7.03843 7.04102C7.03843 6.61004 7.20964 6.19671 7.51438 5.89197C7.81913 5.58722 8.23246 5.41602 8.66343 5.41602H14.1733C14.604 5.41625 15.0171 5.58751 15.3216 5.89214L18.4795 9.04897C18.7841 9.35374 18.9552 9.76699 18.9551 10.1978V18.9577C18.9551 19.3887 18.7839 19.802 18.4791 20.1067C18.1744 20.4115 17.7611 20.5827 17.3301 20.5827H14.053C14.0913 20.3951 14.0893 20.2016 14.0473 20.0149C14.0053 19.8281 13.9241 19.6524 13.8093 19.4993H17.3301C17.4738 19.4993 17.6115 19.4423 17.7131 19.3407C17.8147 19.2391 17.8718 19.1013 17.8718 18.9577V10.8327H15.1634C14.7325 10.8327 14.3191 10.6615 14.0144 10.3567C13.7096 10.052 13.5384 9.63866 13.5384 9.20768V6.49935H8.66343C8.51977 6.49935 8.382 6.55642 8.28042 6.658C8.17883 6.75958 8.12177 6.89736 8.12177 7.04102V12.2226C7.74839 12.2726 7.38378 12.3744 7.03843 12.5248V7.04102ZM15.1634 9.74935H17.6475L14.6218 6.7236V9.20768C14.6218 9.35134 14.6788 9.48912 14.7804 9.5907C14.882 9.69228 15.0198 9.74935 15.1634 9.74935ZM8.66343 19.4993C9.36543 19.4993 10.0154 19.2773 10.5463 18.8981L12.343 20.6948C12.4451 20.7935 12.582 20.8481 12.724 20.8468C12.866 20.8456 13.0019 20.7886 13.1023 20.6882C13.2027 20.5878 13.2597 20.4519 13.2609 20.3099C13.2622 20.1679 13.2076 20.0311 13.1089 19.9289L11.3127 18.1327C11.7349 17.539 11.9454 16.8206 11.9103 16.0928C11.8752 15.3651 11.5966 14.6703 11.1193 14.1199C10.6419 13.5695 9.99345 13.1955 9.278 13.0579C8.56255 12.9202 7.82161 13.027 7.17412 13.361C6.52663 13.695 6.01015 14.2369 5.70758 14.8996C5.40501 15.5624 5.33391 16.3076 5.5057 17.0156C5.67748 17.7237 6.08218 18.3534 6.65483 18.8039C7.22748 19.2543 7.93487 19.4992 8.66343 19.4993ZM8.66343 18.416C8.0888 18.416 7.5377 18.1877 7.13137 17.7814C6.72504 17.3751 6.49677 16.824 6.49677 16.2493C6.49677 15.6747 6.72504 15.1236 7.13137 14.7173C7.5377 14.311 8.0888 14.0827 8.66343 14.0827C9.23807 14.0827 9.78917 14.311 10.1955 14.7173C10.6018 15.1236 10.8301 15.6747 10.8301 16.2493C10.8301 16.824 10.6018 17.3751 10.1955 17.7814C9.78917 18.1877 9.23807 18.416 8.66343 18.416Z" fill="#475367"/>
</svg>


              <div>
              The verifying body evaluates the accuracy and completeness of your emissions reports. 
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
           <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M5.41406 8.26042C5.41406 7.79353 5.59953 7.34576 5.92968 7.01561C6.25982 6.68547 6.70759 6.5 7.17448 6.5H18.8203C19.2872 6.5 19.735 6.68547 20.0651 7.01561C20.3953 7.34576 20.5807 7.79353 20.5807 8.26042V16.1146C20.5807 16.5815 20.3953 17.0292 20.0651 17.3594C19.735 17.6895 19.2872 17.875 18.8203 17.875H11.6432V16.8496L11.6774 16.7917H18.8203C19.1941 16.7917 19.4974 16.4883 19.4974 16.1146V8.26042C19.4974 7.88667 19.1941 7.58333 18.8203 7.58333H7.17448C6.80073 7.58333 6.4974 7.88667 6.4974 8.26042V11.6117C6.07993 11.8527 5.71226 12.1711 5.41406 12.5499V8.26042ZM11.3724 14.8958C11.3724 15.686 11.0585 16.4437 10.4998 17.0024C9.94112 17.5611 9.18335 17.875 8.39323 17.875C7.6031 17.875 6.84534 17.5611 6.28664 17.0024C5.72794 16.4437 5.41406 15.686 5.41406 14.8958C5.41406 14.1057 5.72794 13.3479 6.28664 12.7892C6.84534 12.2305 7.6031 11.9167 8.39323 11.9167C9.18335 11.9167 9.94112 12.2305 10.4998 12.7892C11.0585 13.3479 11.3724 14.1057 11.3724 14.8958ZM10.8307 17.8003C10.1485 18.3746 9.28502 18.6889 8.39323 18.6875C7.50144 18.6889 6.63794 18.3746 5.95573 17.8003V20.0417C5.95575 20.1382 5.98159 20.233 6.03057 20.3163C6.07956 20.3995 6.1499 20.4681 6.23431 20.515C6.31873 20.5619 6.41415 20.5854 6.51069 20.583C6.60723 20.5807 6.70138 20.5525 6.7834 20.5015L8.39323 19.4995L10.0031 20.5015C10.0851 20.5526 10.1793 20.5807 10.2759 20.583C10.3725 20.5854 10.4679 20.5619 10.5524 20.5149C10.6368 20.4679 10.7071 20.3992 10.7561 20.3159C10.805 20.2326 10.8308 20.1377 10.8307 20.0411V17.8003ZM8.66406 10.2917C8.66406 10.148 8.72113 10.0102 8.82271 9.90865C8.92429 9.80707 9.06207 9.75 9.20573 9.75H16.7891C16.9327 9.75 17.0705 9.80707 17.1721 9.90865C17.2737 10.0102 17.3307 10.148 17.3307 10.2917C17.3307 10.4353 17.2737 10.5731 17.1721 10.6747C17.0705 10.7763 16.9327 10.8333 16.7891 10.8333H9.20573C9.06207 10.8333 8.92429 10.7763 8.82271 10.6747C8.72113 10.5731 8.66406 10.4353 8.66406 10.2917ZM13.5391 13.5417C13.3954 13.5417 13.2576 13.5987 13.156 13.7003C13.0545 13.8019 12.9974 13.9397 12.9974 14.0833C12.9974 14.227 13.0545 14.3648 13.156 14.4664C13.2576 14.5679 13.3954 14.625 13.5391 14.625H16.7891C16.9327 14.625 17.0705 14.5679 17.1721 14.4664C17.2737 14.3648 17.3307 14.227 17.3307 14.0833C17.3307 13.9397 17.2737 13.8019 17.1721 13.7003C17.0705 13.5987 16.9327 13.5417 16.7891 13.5417H13.5391Z" fill="#475367"/>
</svg>


              <div>
              Upon approval, they provide their stamp or signatory on your Carbon Monitoring Certificate, enhancing its credibility and aligning it with regional standards. 
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
           <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M13.0009 19.6795C16.6904 19.6795 19.6814 16.6885 19.6814 12.9989C19.6814 9.30935 16.6904 6.31836 13.0009 6.31836C9.3113 6.31836 6.32031 9.30935 6.32031 12.9989C6.32031 16.6885 9.3113 19.6795 13.0009 19.6795Z" stroke="#475367" stroke-width="1.08333"/>
<path d="M13.0026 16.7904C15.0967 16.7904 16.7943 15.0928 16.7943 12.9987C16.7943 10.9046 15.0967 9.20703 13.0026 9.20703C10.9085 9.20703 9.21094 10.9046 9.21094 12.9987C9.21094 15.0928 10.9085 16.7904 13.0026 16.7904Z" stroke="#475367" stroke-width="1.08333"/>
<path d="M13.0069 14.4436C13.8047 14.4436 14.4514 13.7969 14.4514 12.9991C14.4514 12.2014 13.8047 11.5547 13.0069 11.5547C12.2092 11.5547 11.5625 12.2014 11.5625 12.9991C11.5625 13.7969 12.2092 14.4436 13.0069 14.4436Z" fill="#475367"/>
</svg>


              <div>Set energy goal for a 6months time period, monitor your energy usage and earn CloseCarbon credit. </div>
            </div>

            <button
              className="hero-btn mt-10 group text-[16px] text-white flex justify-center items-center border-2 border-[#E4E7EC] py-[6px] gap-[10px] w-[132px]  h-[56px] bg-[#0D924F] rounded-[8px] hover:bg-[#0d713f] transition-all cursor-pointer  hover:-translate-y-0.5 "
              onClick={() => navigate('/template/business')}
            >
              Choose plan
            </button>
          </div>
        </div>
      </div>
        <div className="bg-[#D3EEE0]">
<BusinessFaq/>


      </div>
  <Collaborators />
  
      <Footer />

    </div>
  );
}
